<app-common-modal-form
  header="Annature Registration"
  confirmText="Register"
  closeText="Cancel"
  icon="ic-mail-20"
  [formGroup]="form"
  [isLoading]="isLoading()"
  (close)="close()"
  (confirm)="confirm()"
>
  <div class="pb-3 d-flex flex-column gap-16">
    <app-input label="Name" formControlName="name"/>
    <app-input label="Email" formControlName="email"/>
    <app-input label="Business" formControlName="business"/>
    <app-input label="Phone number (optional)" formControlName="number"/>
  </div>
</app-common-modal-form>
